import { Locale } from '@synergy/models';

import { Attribute } from '../../../../../../common/models/attribute';
import { BaseAutocompleteSuggestionType } from '../../../../../../common/components/autocomplete-list/pool-autocomplete-list';
import { PoolFormAutocompleteList } from '../../../../../../common/components/abstract/form-autocomplete-list';

export interface PartialAttribute extends BaseAutocompleteSuggestionType {
    name: string;
}

interface PoolAttributeAutocompleteListProps {
    items: Attribute[];
    locale: Locale;
    placeholder?: string;
}

export class PoolAttributeAutocompleteList extends PoolFormAutocompleteList<
    Attribute,
    PartialAttribute,
    PoolAttributeAutocompleteListProps
> {
    public placeholder = this.props.placeholder;
    public hideId = true;

    public getSuggestionValue = (suggestion: PartialAttribute) => suggestion && suggestion.name;

    public getPartial = (items: Attribute[]): PartialAttribute[] =>
        items.map(item => ({
            id: item.id,
            name: item.name,
            actions: <div />,
        }));
}
